import React from 'react';

function AppClose() {
  return (
    <div />
  );
}

export default AppClose;
